import React from 'react';
import { motion } from 'framer-motion';
import { navLinks } from '../../data/navigation';
import { TextRoll } from '../TextRoll';
import { MobileMenu } from './MobileMenu';
import { useNavState } from './useNavState';
export function Nav() {
  const {
    scrolled,
    hidden,
    menuOpen,
    setMenuOpen
  } = useNavState();
  const isDark = !scrolled || menuOpen;
  const showBackground = scrolled && !menuOpen;
  return <>
      <motion.header animate={{
      y: hidden && !menuOpen ? '-100%' : '0%'
    }} transition={{
      duration: 0.35,
      ease: [0.45, 0, 0.55, 1]
    }} className={`fixed inset-x-0 top-0 z-40 py-5 transition-colors duration-[350ms] lg:py-[2.75rem] ${isDark ? 'text-white' : 'text-black'}`} data-id="element-22" data-mp="2xay7yr55uy0v">
        <div aria-hidden="true" className={`absolute inset-0 bg-white transition-opacity duration-[350ms] ${showBackground ? 'opacity-100' : 'opacity-0'}`} data-id="element-23" data-mp="2sdg6flth3l2w" />
        <div className="relative z-10 px-5 md:px-10" data-id="element-24" data-mp="qk8kvun9o78k">
          <div className="mx-auto flex max-w-[71.875rem] items-center" data-id="element-25" data-mp="36w2x81048w4e">
            <a href="#top" aria-label="Immersive Studios – home" onClick={() => setMenuOpen(false)} className="roll-link flex items-end font-clash text-[1.25rem] font-semibold uppercase leading-none tracking-[0.02em]" data-id="element-26" data-mp="36u896dtjsnw3">
              <TextRoll label="STUDIOS" data-id="element-27" data-mp="3bnuokdr3j5vl" />
              <TextRoll label="IMMERSIVE" className="mb-[0.6rem]" data-id="element-28" data-mp="2nx71umciuboz" />
            </a>

            <nav aria-label="Primary" className="ml-auto hidden lg:block" data-id="element-29" data-mp="2iydpix8z0qqe">
              <ul className="flex items-start gap-[3.75rem]" data-id="element-30" data-mp="2j08dyljgb0z8">
                {navLinks.map((link, i) => <motion.li key={link.label} initial={{
                y: '100%',
                opacity: 0
              }} animate={{
                y: '0%',
                opacity: 1
              }} transition={{
                duration: 1,
                delay: 0.2 + i * 0.06,
                ease: [0.25, 0.46, 0.45, 0.94]
              }} data-id="element-31" data-mp="2wvsigbyfngn4" data-mpi={i}>
                    <a href={link.href} className="roll-link block text-[1.25rem] font-normal leading-none tracking-[0.01em]" data-id="element-32" data-mp="7b7bkysht7hb">
                      <TextRoll label={link.label} data-id="element-33" data-mp="3620f1alm1gzl" />
                    </a>
                  </motion.li>)}
              </ul>
            </nav>

            <button type="button" aria-expanded={menuOpen} aria-controls="mobile-menu" aria-label={menuOpen ? 'Close menu' : 'Open menu'} onClick={() => setMenuOpen(!menuOpen)} className="ml-auto flex h-10 w-10 flex-col items-center justify-center gap-[0.8rem] lg:hidden" data-id="element-34" data-mp="3ezj5iui0wniv">
              <motion.span animate={menuOpen ? {
              rotate: 45,
              y: '0.45rem'
            } : {
              rotate: 0,
              y: 0
            }} transition={{
              duration: 0.25,
              ease: [0.23, 1, 0.32, 1]
            }} className="block h-[2px] w-10 bg-current" data-id="element-35" data-mp="2w1gcm4mcu6fs" />
              <motion.span animate={menuOpen ? {
              rotate: -45,
              y: '-0.45rem'
            } : {
              rotate: 0,
              y: 0
            }} transition={{
              duration: 0.25,
              ease: [0.23, 1, 0.32, 1]
            }} className="block h-[2px] w-10 bg-current" data-id="element-36" data-mp="23jccyfw7vxxh" />
            </button>
          </div>
        </div>
      </motion.header>
      <MobileMenu open={menuOpen} onClose={() => setMenuOpen(false)} data-id="element-37" data-mp="1i2eqw23sryeg" />
    </>;
}